import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Status = {
  NotFound: lazyNamed(() => import('./pages/NotFound.tsx'), 'NotFound'),
  Forbidden: lazyNamed(() => import('./pages/Forbidden.tsx'), 'Forbidden'),
  Maintenance: lazyNamed(() => import('./pages/Maintenance/index.tsx'), 'Maintenance'),
};

export default Status;
